import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Information */}
        <div className="footer-company-info">
          <div className="company-details">
            <h3 className="footer-logo">RIVER PRIME</h3>
            <p className="company-registration">
              River Prime Ltd. is registered and regulated by Labuan Financial Services Authority (LFSA) under license number MB/19/0039 situated at Office 2, Kim Business Center 2, Unit F28, 1st floor, Paragon Labuan, Jalan Tun Mustapha, 87000 F. T. Labuan, Malaysia.
            </p>
          </div>
        </div>

        {/* Single Center Box */}
        <div className="footer-three-boxes">
          <div className="office-card">
            <div className="office-details">
              <div className="office-info-item">
                <strong>Headquarter</strong>
                <span>Labuan - Malaysia</span>
              </div>

              <div className="office-info-item">
                <strong>Working Hours</strong>
                <span>Monday - Friday</span>
                <span>Available 24/5</span>
              </div>

              <div className="office-info-item">
                <strong>Address</strong>
                <span>
                  Office 2, Kim Business Center 2, Unit F28,
                  1st floor, Paragon Labuan, Jalan Tun Mustapha,
                  87000 F. T. Labuan, Malaysia.
                </span>
              </div>

              <div className="office-info-item">
                <strong>Contact info</strong>
                <span>
                  <a href="tel:+6087586623">+608 758 66 23</a>
                </span>
                <span>
                  <a href="mailto:support@riverprime.my">support@riverprime.my</a>
                </span>
              </div>

             
            </div>
          </div>
        </div>
        {/* Social Media */}
        <div className="footer-social">
          <br />
          <br />
          <h4>followUs</h4>
          <div className="social-links">
            <a href="#" className="social-link" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="social-link" aria-label="Facebook">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="#" className="social-link" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="social-link" aria-label="YouTube">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
        {/* Disclaimer */}
        <div className="footer-disclaimer">
          <p>
            <strong>Risk Warning:</strong> Trading derivatives carries significant risks. It is not suitable for all investors and if you are a professional client, you could lose substantially more than your initial investment. When acquiring our derivative products, you have no entitlement, right or obligation to the underlying financial assets. Past performance is no indication of future performance and tax laws are subject to change. The information on this website is general in nature and doesn’t take into account your personal objectives, financial circumstances, or needs. Accordingly, before acting on the advice, you should consider whether the advice is suitable for you having regard to your objectives, financial situation and needs. We encourage you to seek independent advice if necessary. Please read our legal documents and ensure that you fully understand the risks before you make any trading decisions.
          </p>

          <p>
            River Prime cannot guarantee and assume no legal responsibility for the relevance, accuracy, topicality or completeness of the information.
          </p>

          <p>
            <strong>Regional Restrictions:</strong> We do not offer our services to residents of certain jurisdictions such as the United States, Israel, North Korea and to jurisdictions on the FATF and EU/UN sanctions lists.
          </p>

          <p>
            The information on this site and the products and services offered are not intended for distribution to any person in any country or jurisdiction where such distribution or use would be contrary to local law or Regulation.
          </p>

          <p>
            Clients must have the legal capacity to make contracts and use River Prime&apos;s services.
          </p>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; RIVER PRIME 2025. All rights reserved.</p>
            <div className="footer-legal-links">
              <a href="/documents/SVG - Privacy Policy.pdf" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              <span>|</span>
              <a href="/documents/SVG_-_Terms_&_Conditions (2).pdf" target="_blank" rel="noopener noreferrer">
                Terms of Use
              </a>
              <span>|</span>
              <Link to="/support" onClick={() => window.scrollTo(0, 0)}>
                Support
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;